<script setup lang="ts">
  import { ref } from 'vue'
  import { onClickOutside } from '@vueuse/core'
  import { useAmazonCoversMenuStore } from '@/stores/list-item-menu'
  import { useAmazonCoversStore } from '@/stores/amazon-covers'
  import { usePopupStore } from '@/stores/popup'
  import DesMenuOptions from '@/components/menu/DesMenuOptions.vue'
  import DesMenuItem from '@/components/menu/DesMenuItem.vue'

  const menu = useAmazonCoversMenuStore()
  const covers = useAmazonCoversStore()
  const popup = usePopupStore()

  const target = ref<HTMLElement | null>(null)

  onClickOutside(target, () => menu.item && menu.close())

  const remove = async () => {
    console.log(menu.item)

    const result = await popup.confirm('Are you sure you want to delete this cover?', {
      content: 'This action is irreversible. Original project will not be deleted.',
      labelConfirm: 'Delete',
    })

    if (result === true && menu.item) {
      await covers.remove(menu.item.id)
    }
  }
</script>

<template>
  <div
    class="absolute z-50"
    :style="{ left: menu.position.left + 'px', top: menu.position.top + 'px' }"
    ref="target"
    @click="menu.close()"
  >
    <DesMenuOptions :open="menu.opened" :left="menu.flip" :right="!menu.flip">
      <DesMenuItem @click="() => remove()" icon="fa-light fa-trash-can" danger>Delete</DesMenuItem>
    </DesMenuOptions>
  </div>
</template>
